import { defineComponent, ref } from 'vue-demi';
import isNil from 'lodash/isNil';
import { s as script$1 } from './OrTooltipContent-c0042844.js';
import { s as script$2, O as OrFloatingPlacements } from './OrFloating-00617713.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot, createBlock, withCtx, createVNode, normalizeProps, guardReactiveProps, createCommentVNode } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var script = defineComponent({
  name: 'OrTooltip',
  components: {
    OrTooltipContent: script$1,
    OrFloating: script$2
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    },
    isVisible: {
      type: Boolean,
      required: false,
      default: null
    },
    placement: {
      type: String,
      required: false,
      default: () => OrFloatingPlacements.TOP
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    triggerOnParent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['show', 'hide', 'update:modelValue'],
  setup() {
    const trigger = ref();
    return {
      trigger
    };
  },
  data(props) {
    return {
      isShown: props.modelValue || props.isVisible || false
    };
  },
  watch: {
    modelValue(newValue) {
      if (newValue !== this.isShown) {
        this.isShown = newValue || this.isVisible || false;
      }
    },
    isVisible(newIsVisible) {
      if (newIsVisible !== this.isShown) {
        this.isShown = this.modelValue || newIsVisible || false;
      }
    },
    isShown(nv, ov) {
      if (nv !== ov) {
        this.$emit('update:modelValue', nv);
        this.$emit(nv ? 'show' : 'hide');
      }
    }
  },
  beforeUnmount() {
    this.isShown = false;
  },
  methods: {
    show() {
      if (isNil(this.isVisible)) this.isShown = true;
    },
    hide() {
      if (isNil(this.isVisible)) this.isShown = false;
    }
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_tooltip_content = resolveComponent("or-tooltip-content");
  const _component_or_floating = resolveComponent("or-floating");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["tooltip-container", {
      'fill-parent': _ctx.triggerOnParent
    }])
  }, [createElementVNode("div", {
    ref: "trigger",
    class: normalizeClass(["trigger", {
      'fill-parent': _ctx.triggerOnParent
    }]),
    onMouseover: _cache[0] || (_cache[0] = (...args) => _ctx.show && _ctx.show(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => _ctx.hide && _ctx.hide(...args))
  }, [renderSlot(_ctx.$slots, "default")], 34 /* CLASS, NEED_HYDRATION */), _ctx.isShown ? (openBlock(), createBlock(_component_or_floating, {
    key: 0,
    trigger: _ctx.trigger,
    placement: _ctx.placement,
    offset: 8,
    "is-using-shift": "",
    "is-using-flip": ""
  }, {
    default: withCtx(() => [createVNode(_component_or_tooltip_content, {
      placement: "custom",
      content: _ctx.content
    }, {
      default: withCtx(scope => [renderSlot(_ctx.$slots, "content", normalizeProps(guardReactiveProps(scope)))]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["content"])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["trigger", "placement"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-20a861cc {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-20a861cc {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.fill-parent[data-v-20a861cc] {\n  width: 100% !important;\n  height: 100% !important;\n}\n.tooltip-container[data-v-20a861cc] {\n  position: relative;\n  display: inline-block;\n  width: fit-content;\n  height: fit-content;\n}\n.tooltip-container.fill-parent[data-v-20a861cc] {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.tooltip-container .trigger[data-v-20a861cc] {\n  cursor: pointer;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-20a861cc";
script.__file = "src/components/or-tooltip/OrTooltip.vue";

export { script as s };
